
const calcSalesTax = (priceWithoutTax, salesTax) => {
    return priceWithoutTax * (1 + Number(salesTax));
}
export default calcSalesTax;